/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { Button, FormControl, Popover, Typography } from '@material-ui/core';
import { disableTimeSlots, formatTime, formatTime24hrsOr12hrs, generateOptionsList, generateTimes, isTimeInRange, numberOptions, timeToMinutes, ValidTime } from '../../services/helpers';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { CalendarTodayOutlined } from "@mui/icons-material";
import { format } from "date-fns";
import styles from "./calendar.module.scss";
import SingleSelectNew from '../../components/SelectField/SingleSelectNew';
import AppointmentSelection from './AppointmentSelection';
import { useLocation, useNavigate } from 'react-router';
import AuthContext from '../../hooks/authContext';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: "100%",
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    selectinput: {
        padding: "15px 10px"
    },
    selectlabel: {
        transform: "translate(14px, 15px) scale(1)"
    },
    selectoption: {
        margin: 0
    }
}));

const DateAndTimeSelector = ({ DateTimeProps }) => {
    const {
        empNames, selectedDate, setSelectedDate, startTime, setStartTime, endTime, setEndTime, frequencyData, setFrequencyData, numberOfTime, setNumberOfTime, isInputVisible,
        setInputVisible, timeVisible, setTimeVisible, errors, setErrors, appointmentType, manualDate, setManualDate, handleAddTime, setRecurringDates, handleCancelTime,
        selectedMonth, selectedDay, selectedYear, setSelectedYear, setSelectedDay, setSelectedMonth, daysInMonth, 
        setDaysInMonth, editAppointmentData, settingsData, appointmentId, setSelectedIds, selectedIds, startMeridiem, setStartMeridiem, endMeridiem, setEndMeridiem, setAlert
    } = DateTimeProps;


    const [anchorEl, setAnchorEl] = useState(null);
    const [manualEntry, setManualEntry] = useState(false);
    const [allTimeSlots, setAllTimeSlots] = useState();
    const auth = useContext(AuthContext);
    const updateAppointmentData = auth.updateAppointmentData?.matchingAppointments;
    const location = useLocation();
    const mode = location.state?.mode;
    const [selectionLocked, setSelectionLocked] = useState(false);
    const navigate = useNavigate();
    
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const cleanTime = (val) => {
        if (!val) return val;

        return val?.toLowerCase()?.replace(/am|pm/gi, "")?.trim();
    };

  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);

    const newEndTime = true;
    const intervalStartString = settingsData?.timeInterval || "30 min";
    const intervalStartTime = parseInt(intervalStartString.split(" ")[0], 10);
    const startTimes = generateTimes(intervalStartTime);
    const disabledStartTimeOptions = settingsData?.standardWorkTime === "yes" ?  disableTimeSlots(startTimes, null, null, settingsData?.standardWorkTime) : disableTimeSlots(startTimes, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime);

    const intervalEndString = settingsData?.timeInterval || "30 min";
    const intervalEndTime = parseInt(intervalEndString.split(" ")[0], 10);
    const endTimes = generateTimes(intervalEndTime);
    const disableEndTimeOptions = settingsData?.standardWorkTime === "yes" ?  disableTimeSlots(endTimes, null, null, settingsData?.standardWorkTime, newEndTime, startTime) : disableTimeSlots(endTimes, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, newEndTime, startTime);

    const optionsList = generateOptionsList(selectedDate || manualDate);
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
    const classes = useStyles();
    const endTimeRef = useRef(null);
    const isDarkMode = localStorage?.getItem('darkMode') === 'true';

    const handleLinkClick = () => {
        setInputVisible(!isInputVisible);
        if (!isInputVisible) {
            setSelectedDate(null);
        } else {
            setManualDate(null);
        }
    };

    const handleTimeLinkClick = () => {
        setTimeVisible(!timeVisible);
    };

    const minutesToTime = (minutes) => {
        const hour = Math.floor(minutes / 60) % 12 || 12;
        const minute = minutes % 60;
        const period = minutes < 720 ? "AM" : "PM";
        return `${hour}:${minute.toString().padStart(2, "0")} ${period}`;
    };
    const normalizeTime = (time) => {
        const [hour, rest] = time.trim().split(":");
        const normalizedHour = parseInt(hour, 10);
        return `${normalizedHour}:${rest.toLowerCase()}`;
    };
    
    const scrollToSuggestedEndTime = (suggestedTime) => {
        if (endTimeRef.current) {
            const items = endTimeRef.current.querySelectorAll("label");
            const normalizedSuggestedTime = normalizeTime(suggestedTime);
            const target = Array.from(items).find((item) => {
                const itemText = normalizeTime(item.textContent);
                return itemText === normalizedSuggestedTime
            });
            if (target) {
                target.scrollIntoView({ behavior: "smooth", block: "center" });
            } else {
                console.error("Target not found in list");
            }
        }
    };

    const handleStartTimeChange = (event) => {
        const selectedStartTime = event.target.value;
        setStartTime(selectedStartTime);
        setRecurringDates([]);

        const startMinutes = timeToMinutes(selectedStartTime);
        const suggestedEndTime = minutesToTime(startMinutes + 30);
        scrollToSuggestedEndTime(suggestedEndTime);
    };

    const months = [
       "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 51 }, (_, i) => currentYear + i);

    const getDaysInMonth = (month) => {
        const date = new Date(currentYear, month + 1, 0);
        const dates = [];
        for (let i = 1; i <= date.getDate(); i++) {
            dates.push(i.toString().padStart(2, '0'));
        }
        return dates;
    };

    const getDisabledStartTimeOptions = (timeSlots, selectedDate) => {
        const now = dayjs();
        const selected = dayjs(selectedDate);
        
        const isToday = selected.isSame(now, 'day');
        
        return timeSlots.map((slot) => {
            const slotTime = dayjs(`${selected.format('YYYY-MM-DD')} ${slot.time}`, 'YYYY-MM-DD hh:mm a');
            const isDisabled = isToday && slotTime.isBefore(now);
            
            return {
                ...slot,
                disabled: isDisabled,
            };
        });
    };

    const getDayOfWeek = (date, month, year) => {
        if (!year) {
            year = new Date().getFullYear();
        }
        const dateObject = new Date(year, month, date);
        const dayOfWeek = dateObject.getDay();
        const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
        return dayNames[dayOfWeek];
    };

    const manualDateSet = (selectedMonth, selectedDay, selectedYear) => {
        if (selectedMonth !== null && selectedDay !== null && selectedYear !== null) {
            const monthIndex = selectedMonth;
            const formattedDate = dayjs(
                `${selectedYear}-${(monthIndex + 1).toString().padStart(2, "0")}-${selectedDay.toString().padStart(2, "0")}`
            );
            setManualDate(formattedDate);
        }
    }

    const startTimeOptions = allTimeSlots?.map((slot) => ({
    label: formatTime24hrsOr12hrs(slot?.time, settingsData?.timeFormat),
    value: slot?.time,
    // disabled: slot?.disabled,
    }));

    const endTimeOptions = disableEndTimeOptions?.map((slot) => {
    const formattedTime = formatTime24hrsOr12hrs(
        slot?.time,
        settingsData?.timeFormat
    );
    const endMinutes = timeToMinutes(slot?.time);
    const startMinutes = timeToMinutes(startTime);
    const isDisabled =
        !startTime || endMinutes === startMinutes || slot?.time === startTime;

    return {
        label: formattedTime + (slot?.nextDay ? " (Next Day)" : ""),
        value: slot?.time,
        disabled: slot?.disabled || isDisabled,
    };
    });

    useEffect(() => {
        const date = selectedDate ? selectedDate : manualDate;
        const updatedSlots = getDisabledStartTimeOptions(disabledStartTimeOptions, date);
        setAllTimeSlots(updatedSlots);
    }, [selectedDate, manualDate]);

    const handleMonthChange = (e) => {
        const month = months.indexOf(e.target.value);
        setSelectedMonth(month);
        const days = getDaysInMonth(month);
        setDaysInMonth(days);
        setSelectedDay(null);
    };

    const handleDateChange = (e) => {
        setSelectedDay(e.target.value);
        setSelectedYear(null);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
        manualDateSet(selectedMonth, selectedDay, e.target.value);
    };
    
    const checkInTime = editAppointmentData?.checkInDateTime?.seconds 
    ? moment.unix(editAppointmentData.checkInDateTime.seconds).tz(editAppointmentData?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;
    
    const checkOutTime = editAppointmentData?.checkOutDateTime?.seconds 
    ? moment.unix(editAppointmentData.checkOutDateTime.seconds).tz(editAppointmentData?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;

    const locakedState = appointmentId && appointmentType === "Recurring Appointment" ? (appointmentId && mode !== "this" && selectionLocked === true): true;

    return (
        <>
        <div className={isMobile ? 'd-flex flex-direction-column flex-space-between w-100 mt-15' : 'd-flex flex-center flex-space-between w-100 mt-15'}>
                <div className='width50'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div>
                            <Typography variant='body'  className={`${styles.timeInputLabel} mb-8 dark:text-white`}>Date</Typography>
                            <Button
                                onClick={handleOpen}
                                variant="outlined"
                                fullWidth
                                sx={{
                                    justifyContent: "flex-start",
                                    height: 48,
                                    paddingLeft: 2,
                                    color: selectedDate ? "text.primary" : "text.secondary",
                                    borderColor: errors.date ? "#ff0000" : "#f1f5f9",
                                }}
                                style={{padding:"8px 16px"}}
                                startIcon={<CalendarTodayOutlined  className='dark:text-white'/>}
                            >
                                <span className='text-[#020817] dark:text-white' style={{fontSize:"14px", fontWeight:"400", lineHeight:"20px"}}>
                                    {selectedDate ? format(new Date(selectedDate), "PPP") : "No date selected"} </span>
                            </Button>

                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                 PaperProps={{
                                    sx: {
                                    mt: 1,
                                    p: 1,
                                    boxShadow: 3,
                                    borderRadius: 2,
                                    backgroundColor: isDarkMode ? '#1A1F2C' : '#fff',
                                    color: isDarkMode ? '#fff' : '#000',
                                    },
                                }}
                            >
                                <DateCalendar
                                    value={dayjs(selectedDate)}
                                    onChange={(newValue) => {
                                        setSelectedDate(newValue);
                                        handleClose();
                                        setRecurringDates([]);
                                        if (appointmentId) {
                                            setAlert(true);
                                        } 
                                    }}
                                    shouldDisableDate={(date) => {
                                        if (!settingsData?.workWeek || settingsData?.workWeek?.length === 0) {
                                            return false;
                                        }
                                        const dayName = date?.format("dddd").toLowerCase();
                                        return !settingsData?.workWeek.includes(dayName);
                                    }}
                                    // disabled={!!appointmentId}
                                    disabled={!!checkInTime || (appointmentId && appointmentType === "Recurring Appointment" && mode !== "this" ? !selectionLocked : false)}
                                    sx={{
                                        backgroundColor: isDarkMode ? "#1A1F2C" : "#fff",
                                        color: isDarkMode ? "#fff" : "#000",
                                        borderRadius: 2,

                                        // Week day labels (Su, Mo, ...)
                                        "& .MuiDayCalendar-weekDayLabel": {
                                        color: isDarkMode ? "#fff" : "#000",
                                        },

                                        // Individual days
                                        "& .MuiPickersDay-root": {
                                        color: isDarkMode ? "#fff" : "#000",
                                        },

                                        // Selected day
                                        "& .MuiPickersDay-root.Mui-selected": {
                                        backgroundColor: isDarkMode ? "#2980ba" : "#1976d2",
                                        color: "#fff",
                                        },

                                        // Month navigation icons
                                        "& .MuiPickersCalendarHeader-label": {
                                        color: isDarkMode ? "#fff" : "#000",
                                        },
                                        "& .MuiPickersArrowSwitcher-root button": {
                                        color: isDarkMode ? "#fff" : "#000",
                                        },
                                    }}
                                />
                            </Popover>

                            {errors.date && (
                                <Typography variant="caption" color="error">
                                    Please select a date
                                </Typography>
                            )}
                        </div>
                    </LocalizationProvider>
                </div>
                <div className={isMobile ? 'width50 mt-15' : 'width50 ml-15'}>
                    <div>
                        <Typography variant='body'  className={styles.timeInputLabel}>Time Input Method</Typography>
                        <div className={`${styles.buttonGroup} mt-8`}>
                            <Button
                                variant={manualEntry ? "outlined" : "contained"}
                                className={`${styles.timeButton} ${!manualEntry ? styles.active : ''} dark:text-white`}
                                onClick={() => setManualEntry(false)}
                            >
                                Dropdown
                            </Button>
                            <Button
                                variant={!manualEntry ? "outlined" : "contained"}
                                className={`${styles.timeButton} ${manualEntry ? styles.active : ''} dark:text-white`}
                                onClick={() => setManualEntry(true)}
                            >
                                Manual
                            </Button>
                        </div>
                    </div>
                </div>
        </div>
            <div>
                {!manualEntry && (
                    <div className={isMobile ? 'd-flex flex-direction-column mt-15 w-100' : 'mt-15 d-flex flex-center w-100'}>
                        <div className='width50'>
                            <Typography variant="body" component="label" htmlFor="time-picker" className='text-[#323744] dark:text-white' style={{ fontSize: "16px", fontWeight: "600" }}>
                                Start Time
                            </Typography>
                            <div className='mt-10 mb-20'>
                                <FormControl fullWidth variant="outlined">
                                    <SingleSelectNew
                                        value={startTime}
                                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                                        onChange={(value) => {
                                            setStartTime(value);
                                            // const isInRange = value && isTimeInRange(value, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true);
                                            // if (!isInRange.isValid) {
                                            //     setErrors({
                                            //         ...errors,
                                            //         startTime: true,
                                            //         text: isInRange.error || "Time is out of range",
                                            //     });
                                            // } else {
                                            //     setErrors({ ...errors, startTime: false });
                                            // }
                                            setRecurringDates([]);
                                            setEndTime('');
                                            if (appointmentId) {
                                              setAlert(true);
                                            }
                                            setErrors({ ...errors, startTime: false });
                                            if (startTime === '' && !appointmentId) {
                                                setEndTime('');
                                            }
                                        }}
                                        options={startTimeOptions}
                                        placeholder="Select Start Time"
                                        disabled={!locakedState || ((checkInTime || checkOutTime) ? true : (!selectedDate && !manualDate))}
                                    />

                                </FormControl>
                               {errors?.startTime || errors?.startTime?.hasError && ( <p className="mt-4" style={{ color: '#fc8600' }}>Choose One</p>)}
                            </div>
                        </div>
                        <div className={isMobile ? 'mb-10 mt-15 width50' : 'ml-15 width50'}>
                            <Typography variant="body" component="label" htmlFor="time-picker" className='text-[#323744] dark:text-white' style={{ fontSize: "16px", fontWeight: "600" }}>
                                End Time
                            </Typography>
                            <div className='mt-10 mb-20'>
                                <FormControl fullWidth variant="outlined">
                                    <SingleSelectNew
                                        value={endTime}
                                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                                        onChange={(value) => {
                                            setEndTime(value);
                                            setRecurringDates([]);
                                            // const isInRange = value && isTimeInRange(value, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true, startTime);
                                            // if (!isInRange.isValid) {
                                            //     setErrors({
                                            //         ...errors,
                                            //         endTime: true,
                                            //         text: isInRange.error || "Time is out of range",
                                            //     });
                                            // } else {
                                            //     setErrors({ ...errors, endTime: false });
                                            // }
                                            // filterAppointmentOnTheDate(value);
                                            setErrors({ ...errors, endTime: false });
                                            if (appointmentId) {
                                              setAlert(true);
                                            }
                                            if (endTime === '' && !appointmentId) {
                                                setFrequencyData();
                                            }
                                        }}
                                        options={endTimeOptions}
                                        placeholder="Select End Time"
                                        disabled={!locakedState || !ValidTime(startTime)}
                                    />
                                </FormControl>
                                {(errors?.endTime || errors?.endTime?.hasError) && ( <p className="mt-4" style={{ color: '#fc8600' }}>Choose One</p>)}
                            </div>
                        </div>
                    </div>
                )}
                {manualEntry && (
                    <div className={isMobile ? 'd-flex flex-direction-column mt-15 w-100' : 'mt-15 d-flex flex-center w-100'}>
                        <div className="width50">
                            <Typography variant="body" component="label" className='text-[#323744] dark:text-white'
                                style={{ fontSize: "16px", fontWeight: "600" }}>
                                Start Time
                            </Typography>

                            <div className={isMobile ? "pt-6 pl-2" : 'pt-8 pb-20'}>

                                <div style={{ display: "flex", gap: "10px" }}>
                                    
                                    <input
                                        type="text"
                                        value={cleanTime(startTime) || ""}
                                        placeholder="HH:MM"
                                        disabled={!locakedState || ((checkInTime || checkOutTime) ? true : (!selectedDate && !manualDate))}
                                        className="dark:bg-[#2c3440] dark:text-white"
                                        style={{
                                            width: isMobile || isLandscape ? "250px" : "100%",
                                            height: "40px",
                                            border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                                            padding: "0 5px",
                                            borderRadius: "4px"
                                        }}
                                        onChange={(event) => {
                                            let inputValue = event.target.value;

                                            if (!/^[0-9:]*$/.test(inputValue)) return;

                                            inputValue = inputValue.replace(/am|pm/gi, "");

                                            if (!inputValue.includes(":")) {
                                                if (/^\d+$/.test(inputValue) && inputValue.length > 4) {
                                                    setErrors({
                                                        ...errors,
                                                        startTime: true,
                                                    });
                                                    return;
                                                }
                                            }

                                            if (/^\d{2}$/.test(inputValue) && parseInt(inputValue) > 59) {
                                                setErrors({
                                                    ...errors,
                                                    startTime: true,
                                                });
                                                return;
                                            }

                                            setStartTime(inputValue);
                                            setEndTime('');
                                            setRecurringDates([]);

                                            if (!inputValue || !startMeridiem) {
                                                setErrors({ ...errors, startTime: false });
                                                return;
                                            }

                                            const combinedTime = `${inputValue} ${startMeridiem}`;
                                            setStartTime(combinedTime);

                                            if (appointmentId) {
                                              setAlert(true);
                                            }

                                            const normalizedTime = formatTime(combinedTime);
                                            const isValidFormat = normalizedTime !== "Invalid time";
                                            const isInRange = isValidFormat && isTimeInRange(normalizedTime, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true);

                                            if (!isValidFormat) {
                                                setErrors({
                                                    ...errors,
                                                    startTime: true,
                                                    text: `"${inputValue}" is not a valid time format`,
                                                });
                                            } else if (!isInRange.isValid) {
                                                setErrors({
                                                    ...errors,
                                                    startTime: true,
                                                    text: isInRange.error || "Time is out of range",
                                                });
                                            } else {
                                                setErrors({ ...errors, startTime: false });
                                            }

                                            if (inputValue === "" && !appointmentId) {
                                                setEndTime("");
                                            }
                                        }}
                                    />

                                    <select
                                        value={startMeridiem || ""}
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            setStartMeridiem(selected);

                                            if (!startTime) return;

                                            const pureTime = cleanTime(startTime);
                                            const combinedTime = `${pureTime} ${selected}`;
                                            setStartTime(combinedTime);
                                            setEndTime('');
                                            const normalizedTime = formatTime(combinedTime);
                                            const isValidFormat = normalizedTime !== "Invalid time";
                                            const isInRange = isValidFormat && isTimeInRange(normalizedTime, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true);

                                            if (!isValidFormat) {
                                                setErrors({
                                                    ...errors,
                                                    startTime: true,
                                                    text: `"${startTime}" is not a valid time format`,
                                                });
                                            } else if (!isInRange.isValid) {
                                                setErrors({
                                                    ...errors,
                                                    startTime: true,
                                                    text: isInRange.error || "Time is out of range",
                                                });
                                            } else {
                                                setErrors({ ...errors, startTime: false });
                                            }
                                        }}

                                        style={{ 
                                            width: "120px", 
                                            height: "40px", 
                                            borderRadius: "4px",
                                            border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                                            padding: "0 8px"
                                        }}
                                        className="dark:bg-[#2c3440] dark:text-white"
                                    >
                                        <option value="">Select One</option>
                                        <option value="am">AM</option>
                                        <option value="pm">PM</option>
                                    </select>

                                </div>

                                {errors?.startTime?.hasError && (
                                    <p className="mt-4" style={{ color: '#fc8600' }}>
                                        {errors?.startTime?.text}
                                    </p>
                                )}
                                {errors?.startTime && (
                                    <p className="mt-6" style={{ color: '#fc8600' }}>
                                        Enter a valid time (e.g., 9, 9:30, 09:30)
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className={isMobile ? 'mb-10 mt-15 width50' : 'ml-15 width50'}>
                            <Typography variant="body" component="label" className='text-[#323744] dark:text-white'
                                style={{ fontSize: "16px", fontWeight: "600" }}>
                                End Time
                            </Typography>

                            <div className={isMobile ? "pt-6 pb-20 pl-2" : 'pt-8 pb-20'}>

                                <div style={{ display: "flex", gap: "10px" }}>

                                    <input
                                        type="text"
                                        value={cleanTime(endTime) || ""}
                                        placeholder="HH:MM"
                                        disabled={!locakedState || (manualEntry ? !startMeridiem || !ValidTime(startTime) : !ValidTime(startTime))}
                                        className="dark:bg-[#2c3440] dark:text-white"
                                        style={{
                                            width: isMobile || isLandscape ? "250px" : "100%",
                                            height: "40px",
                                            border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                                            padding: "0 5px",
                                            borderRadius: "4px"
                                        }}

                                        onChange={(event) => {
                                            let inputValue = event.target.value;

                                            if (!/^[0-9:]*$/.test(inputValue)) return;

                                            inputValue = inputValue.replace(/am|pm/gi, "");

                                            if (!inputValue.includes(":")) {
                                                if (/^\d+$/.test(inputValue) && inputValue.length > 4) {
                                                    setErrors({
                                                        ...errors,
                                                        endTime: true,
                                                    });
                                                    return;
                                                }
                                            }

                                            if (/^\d{2}$/.test(inputValue) && parseInt(inputValue) > 59) {
                                                setErrors({
                                                    ...errors,
                                                    endTime: true,
                                                });
                                                return;
                                            }

                                            setEndTime(inputValue);
                                            setRecurringDates([]);

                                            if (!inputValue || !endMeridiem) {
                                                setErrors({ ...errors, endTime: false });
                                                return;
                                            }

                                            const combinedTime = `${inputValue} ${endMeridiem}`;
                                            setEndTime(combinedTime);

                                            if (appointmentId) {
                                              setAlert(true);
                                            }

                                            const normalizedTime = formatTime(combinedTime);
                                            const isValidFormat = normalizedTime !== "Invalid time";
                                            const isInRange = isValidFormat && isTimeInRange(normalizedTime, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true, startTime);

                                            if (!isValidFormat) {
                                                setErrors({
                                                    ...errors,
                                                    endTime: true,
                                                    text: `"${inputValue}" is not a valid time format`,
                                                });
                                            } else if (!isInRange.isValid) {
                                                setErrors({
                                                    ...errors,
                                                    endTime: true,
                                                    text: isInRange.error || "Time is out of range",
                                                });
                                            } else {
                                                setErrors({ ...errors, endTime: false });
                                            }
                                            if (inputValue === '' && !appointmentId) {
                                                setFrequencyData()
                                            }
                                        }}
                                    />

                                    <select
                                        value={endMeridiem || ""}
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            setEndMeridiem(selected);

                                            if (!endTime) return;

                                            const pureTime = cleanTime(endTime);
                                            const combinedTime = `${pureTime} ${selected}`;
                                            setEndTime(combinedTime);
                                            const normalizedTime = formatTime(combinedTime);
                                            const isValidFormat = normalizedTime !== "Invalid time";
                                            const isInRange = isValidFormat && isTimeInRange(normalizedTime, settingsData?.startTime, settingsData?.endTime, settingsData?.standardWorkTime, true);

                                            if (!isValidFormat) {
                                                setErrors({
                                                    ...errors,
                                                    endTime: true,
                                                    text: `"${startTime}" is not a valid time format`,
                                                });
                                            } else if (!isInRange.isValid) {
                                                setErrors({
                                                    ...errors,
                                                    endTime: true,
                                                    text: isInRange.error || "Time is out of range",
                                                });
                                            } else {
                                                setErrors({ ...errors, endTime: false });
                                            }
                                        }}
                                        style={{ 
                                            width: "120px", 
                                            height: "40px", 
                                            borderRadius: "4px",
                                            border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                                            padding: "0 8px"
                                        }}
                                        className="dark:bg-[#2c3440] dark:text-white"
                                    >
                                        <option value="">Select One</option>
                                        <option value="am">AM</option>
                                        <option value="pm">PM</option>
                                    </select>

                                </div>

                                {errors?.endTime?.hasError && (
                                    <p className="mt-4" style={{ color: '#fc8600' }}>
                                        {errors?.endTime?.text}
                                    </p>
                                )}
                                {errors?.endTime && (
                                    <p className="mt-6" style={{ color: '#fc8600' }}>
                                        Enter a valid time (e.g., 9, 9:30, 09:30)
                                    </p>
                                )}
                            </div>
                        </div>
                </div>
                )}
            </div>

            {appointmentType === "Recurring Appointment" && (
                <>
                    <div className={isMobile ? 'mt-15 d-flex flex-direction-column w-100' :'mt-10 d-flex flex-center w-100'}>
                        <div className='mb-10 width50'>
                            <Typography
                                variant="body"
                                component="label"
                                htmlFor="time-picker"
                                className='text-[#323744] dark:text-white'
                                style={{ fontSize: "16px", fontWeight: "600"}}
                            >
                                Frequency
                            </Typography>
                            <div className="mt-10">
                                <SingleSelectNew
                                value={frequencyData}
                                contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                                itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                                onChange={(value) => {
                                    setFrequencyData(value);
                                    setRecurringDates([]);
                                    setErrors({ ...errors, frequency: false });
                                    if (appointmentId) {
                                        setAlert(true);
                                    }
                                    if (!value && !appointmentId) {
                                        setNumberOfTime();
                                    }
                                }}
                                options={optionsList?.map((item) => ({
                                    label: item?.label,
                                    value: item?.value,
                                }))}
                                placeholder="Select Frequency"
                                disabled={
                                    !!checkInTime ||
                                    !locakedState || (
                                    manualEntry
                                        ? !endTime || !endMeridiem
                                        : (
                                            !endTime ||
                                            (appointmentId &&
                                                (appointmentType === "One Time" ||
                                                    (appointmentType === "Recurring Appointment" && mode === "this")
                                                )
                                            )
                                        )
                                    )
                                }
                                />
                                {errors.frequency && <p className="mt-4" style={{ color: '#fc8600' }}>Choose One</p>}
                            </div>
                        </div>

                        <div className={isMobile ? 'mb-10 mt-15 width50' :'mb-10 ml-15 width50'}>
                            <Typography
                                variant="body"
                                component="label"
                                htmlFor="time-picker"
                                className='text-[#323744] dark:text-white'
                                style={{ fontSize: "16px", fontWeight: "600"}}
                            >
                                Number Of Times
                            </Typography>
                            <div className="mt-10">
                                <SingleSelectNew
                                value={numberOfTime}
                                contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                                itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                                onChange={(value) => {
                                    setNumberOfTime(value);
                                    setRecurringDates([]);
                                    if (appointmentId) {
                                        setAlert(true);
                                    }
                                    setErrors({ ...errors, numberOfTimes: false });
                                }}
                                options={numberOptions?.map((num) => ({
                                    label: num?.label,
                                    value: num?.value,
                                }))}
                                placeholder="Number Of Times"
                                disabled={!!checkInTime || !locakedState || (!frequencyData || !!appointmentId)}
                                />
                                {errors.numberOfTimes && <p className="mt-4" style={{ color: '#fc8600' }}>Choose number 2 or greater than number 2</p>}
                            </div>
                        </div>
                    </div>
                    </>
                )}

                    {appointmentId && (
                        <AppointmentSelection
                            appointments={updateAppointmentData}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            selectionLocked={selectionLocked}
                            setSelectionLocked={setSelectionLocked}
                            navigate={navigate}
                            setNumberOfTime={setNumberOfTime}
                            setRecurringDates={setRecurringDates}
                            mode={mode}
                            editAppointmentData={[editAppointmentData]}
                        />
                    )}

                    {appointmentType === "Recurring Appointment" && (
                        <div
                            className='mt-25'
                            style={{
                                display: (isMobile || isLandscape) ? "flex" : "",
                                justifyContent: (isMobile || isLandscape) ? "center" : ""
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={handleAddTime}
                                style={{ marginRight: '10px', backgroundColor: '#10bf63', color: 'white', boxShadow: 'none' }}
                                disabled={appointmentId ? !selectionLocked : !numberOfTime}
                            >
                                Add Time
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleCancelTime}
                                style={{ backgroundColor: '#7f7f7f', color: "white", boxShadow: 'none' }}
                                disabled={!numberOfTime}
                            >
                                Cancel
                            </Button>
                        </div>
                    )}
        </>
    );
};

export default DateAndTimeSelector;